// extracted by mini-css-extract-plugin
export default {"inlineEdit":"WCjWRXCJ3Ok0a2VvTwFV","inlineEditValue":"KcEQruriAlEH8CG0u6Rl","inlineEditInput":"E56otyaMq0ncPYH6CvXs"};